//
//
//
//
//
//

import MyTable from '@/components/common_flexTable.vue'
import PageBtns from "@/components/common_pageBtns.vue";
export default {
  name: '',
  components: { MyTable, PageBtns },
  data () {
    return {
      tableConfig: {
        thList: [
          {text: '序号', width: '15%'},
          {text: '产品名称', width: '20%'},
          {text: '账面库存/扫码库存', flex: '1'},
        ],
        trList: [ ]
      },
      btnConfig: {
        bottom: '30px',
        list: [
          {text:'库存核算', type: 'warn', action: () => this.$msg.confirm(
            '如果库存数据不准确，可以执行库存核算功能，进行调整，是否执行库存核算？'
          )},
          {text:'返回', type: 'primary', action: () => this.$router.go(-1)},
        ],
      },
    }
  },
  computed: {},
  methods: {}
}
